import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Link from '../../../elements/Link';

export interface FareItemOriginDestinationProps {
  origin?: string;
  destination?: string;
  originLabelKey?: string;
  destinationLabelKey?: string;
  originStyles?: StyledProps;
  originLabelStyles?: StyledProps;
  originAirportCodeStyles?: StyledProps;
  prepositionLabelStyles?: StyledProps;
  originCityStyles?: StyledProps;
  destinationStyles?: StyledProps;
  destinationLabelStyles?: StyledProps;
  destinationAirportCodeStyles?: StyledProps;
  destinationCityStyles?: StyledProps;
  showOriginLabel?: boolean;
  originCity?: string;
  showDestinationLabel?: boolean;
  destinationCity?: string;
  showOrigin?: boolean;
  showDestination?: boolean;
  showOriginCityName?: boolean;
  showOriginAirportCode?: boolean;
  showDestinationCityName?: boolean;
  showDestinationAirportCode?: boolean;
  showLineSeparator?: boolean;
  showSeparator?: boolean;
  separatorKey?: string;
  separatorStyles?: $TSFixMe;
  separatorIcon?: string;
  separatorIconStyles?: StyledProps;
  lineSeparatorStyles?: StyledProps;
  showSeparatorIcon?: boolean;
  showPrepositionLabel?: boolean;
  formatOneLabel?: boolean;
  showParenthesis?: boolean;
  id?: string;
  linkSettings?: $TSFixMe;
}

function FareItemOriginDestination({
  origin = '',
  destination = '',
  showOriginLabel = false,
  originCity = '',
  destinationLabelKey = 'cmp-preposition--destination-place',
  destinationLabelStyles,
  destinationAirportCodeStyles,
  destinationCityStyles,
  originLabelKey = 'cmp-preposition--origin-place',
  originLabelStyles,
  originCityStyles,
  originStyles,
  destinationStyles,
  originAirportCodeStyles,
  prepositionLabelStyles = {},
  showDestinationLabel = false,
  destinationCity = '',
  showOrigin = true,
  showDestination = true,
  showOriginCityName = true,
  showOriginAirportCode = false,
  showDestinationCityName = true,
  showDestinationAirportCode = false,
  separatorKey = 'minus',
  showLineSeparator = false,
  showSeparator = true,
  separatorStyles,
  showSeparatorIcon = false,
  separatorIcon,
  separatorIconStyles,
  lineSeparatorStyles,
  showPrepositionLabel = false,
  formatOneLabel = false,
  showParenthesis = true,
  id,
  linkSettings,
  ...props
}: StyledProps<FareItemOriginDestinationProps>) {
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const renderOneLabel = () => {
    const labels = [];
    if (showOriginLabel) {
      labels.push(translate(originLabelKey, 'From'));
    }
    if (showOriginCityName) {
      labels.push(originCity);
    }
    if (showOriginAirportCode) {
      if (showParenthesis) {
        labels.push(`(${origin})`);
      } else {
        labels.push(origin);
      }
    }
    if (showSeparator) {
      labels.push(translate(`cmp-separator-${separatorStyles?.content}`, separatorKey));
    }
    if (showDestinationLabel) {
      labels.push(translate(destinationLabelKey, 'To'));
    }
    if (showDestinationCityName) {
      labels.push(destinationCity);
    }
    if (showDestinationAirportCode) {
      if (showParenthesis) {
        labels.push(`(${destination})`);
      } else {
        labels.push(destination);
      }
    }

    if (direction === 'rtl') {
      // This fix the issue for join arabic characters.
      // Insert Unicode direction marks: \u200E --> LTR or \u200F --> RTL
      // In this case use LTR mark because we revert the text by code and join it from left to right
      return labels.reverse().join('\u200E ');
    }
    return labels.join(' ');
  };
  return (
    <Box
      className={`fare-item-origin-destination ${className} fr-clearfix`}
      style={style}
      id={id}
      role="heading"
      ariaLevel={3}
      ariaLabel={renderOneLabel()}
    >
      <Link className="fare-item-origin-city-name" {...linkSettings}>
        {renderOneLabel()}
      </Link>
    </Box>
  );
}

FareItemOriginDestination.componentName = 'FareItemOriginDestination';

export default FareItemOriginDestination;
